import { useCallback } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import MaldivesBanner from 'components/MaldivesDirect/MaldivesBanner'
import { useMaldivesBannerPrice } from 'components/MaldivesDirect/useMaldivesBannerPrice'
import { CHARTER_PAGE_SLUG, MALDIVES_BUNDLE_DEFAULT_NIGHTS, MALDIVES_FLIGHTS_LANDING_CAMPAIGN_NAME } from 'constants/charterFlight'
import { useAppDispatch } from 'hooks/reduxHooks'
import { pushWithRegion } from 'actions/NavigationActions'

const MALDIVES_BANNER_DEFAULT_ROOMS: Array<App.Occupants> = [{ adults: 2, teenagers: 0 }]
const MALDIVES_DIRECT_CHEAPEST_SEARCH = 'sortBy=price.asc'

const MaldivesBannerContainer = styled(LayoutContainer)`
  padding-block-start: ${rem(24)};
  padding-block-end: ${rem(24)};
`

/**
 * Agent Hub–only flights landing banner. LuxPlus member pricing is not available on Agent Hub,
 * so we always use the regular (non-member) price — matching the first tile on
 * /campaign/maldives-direct?sortBy=price.asc (2 adults, 5-night default).
 */
function AgentHubFlightsSearchMaldivesBundlesBanner() {
  const dispatch = useAppDispatch()
  const { maldivesBundlePrice, isMaldivesBundlePriceLoading } = useMaldivesBannerPrice({
    enabled: true,
    nights: MALDIVES_BUNDLE_DEFAULT_NIGHTS,
    rooms: MALDIVES_BANNER_DEFAULT_ROOMS,
    useMemberPrice: false,
    useStreamSearchForAnytime: true,
  })

  const handleViewBundlesClick = useCallback(() => {
    dispatch(pushWithRegion(`/campaign/${CHARTER_PAGE_SLUG}`, MALDIVES_DIRECT_CHEAPEST_SEARCH))
  }, [dispatch])

  return (
    <MaldivesBannerContainer>
      <MaldivesBanner
        onViewBundlesClick={handleViewBundlesClick}
        price={maldivesBundlePrice}
        nights={MALDIVES_BUNDLE_DEFAULT_NIGHTS}
        isPriceLoading={isMaldivesBundlePriceLoading}
        promotionName={MALDIVES_FLIGHTS_LANDING_CAMPAIGN_NAME}
      />
    </MaldivesBannerContainer>
  )
}

export default AgentHubFlightsSearchMaldivesBundlesBanner
